import { Body, Controller, Post } from "@nestjs/common";
import { VendorRegService } from "./vendor-registration.service";

@Controller("vendors")
export class VendorsController {
  constructor(
    private vendorService :VendorRegService
  ){}

  @Post('/createVendor')
  async createVendor(@Body() req: any): Promise<any> {
      try {
          return await this.vendorService.createVendor(req);
      } catch (error) {
          console.log(error)
      }
  }

  @Post('/getVendorsData')
  async getVendorsData(): Promise<any> {
      try {
          return await this.vendorService.getVendorsData();
      } catch (error) {
          console.log(error)
      }
  }

  @Post('/updateRejectStatus')
  async updateRejectStatus(@Body() req: any): Promise<any> {
      try {
          return await this.vendorService.updateRejectStatus(req);
      } catch (error) {
          console.log(error)
      }
  }

  @Post('/updateApproveStatus')
  async updateApproveStatus(@Body() req: any): Promise<any> {
      try {
          return await this.vendorService.updateApproveStatus(req);
      } catch (error) {
          console.log(error)
      }
  }

}